<template>
  <!-- 二十届中央领导机构 -->
  <div class="latelybox1">
    <table
      border="0"
      cellpadding="0"
      cellspacing="0"
      class="list"
      v-if="windowWidth > 769"
    >
      <tbody>
        <tr>
          <td colspan="4" style="font-weight: bold; color: #ac0002">
            二十届中央领导机构
          </td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">国家主席：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">习近平</a>
          </td>
          <td class="t3">
            <a @click="leaderName($event)" class="l_txt">副主席：</a>
          </td>
          <td class="t4">
            <a @click="leaderName($event)" class="l_txt ll">韩正</a>
          </td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">国务院总理：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">李强</a>
          </td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">国务院副总理：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">丁薛祥</a>
            <a @click="leaderName($event)" class="l_txt ll">何立峰 </a>
            <a @click="leaderName($event)" class="l_txt ll">张国清 </a>
            <a @click="leaderName($event)" class="l_txt ll">刘国中 </a>
          </td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">国务委员：</a>
          </td>
          <td class="t2">
            <!--<a href='javascript:SGoAttrWith("220101","国务委员,李尚福")' class="l_txt ll">李尚福 </a>-->
            <a @click="leaderName($event)" class="l_txt ll">王小洪</a>
            <a @click="leaderName($event)" class="l_txt ll">吴政隆</a>
            <a @click="leaderName($event)" class="l_txt ll">谌贻琴</a>
            <!--<a href='javascript:SGoAttrWith("220101","国务委员,秦刚")' class="l_txt ll">秦刚</a>-->
          </td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">国务院秘书长：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">吴政隆（兼）</a>
          </td>
          <td class="t3"><a href="#" class="l_txt"></a></td>
          <td class="t4"><a href="#" class="l_txt ll"></a></td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">全国人大委员长：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">赵乐际</a>
          </td>
          <td class="t3"><a href="#" class="l_txt"></a></td>
          <td class="t4"><a href="#" class="l_txt ll"></a></td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">全国人大副委员长：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">李鸿忠</a>
            <a @click="leaderName($event)" class="l_txt ll">王东明</a>
            <a @click="leaderName($event)" class="l_txt ll">肖捷 </a>
            <a @click="leaderName($event)" class="l_txt ll">郑建邦</a>
            <a @click="leaderName($event)" class="l_txt ll">丁仲礼</a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">郝明金</a>

            <a @click="leaderName($event)" class="l_txt ll">蔡达峰</a>
            <a @click="leaderName($event)" class="l_txt ll">何维</a>

            <a @click="leaderName($event)" class="l_txt ll">武维华</a>
            <a @click="leaderName($event)" class="l_txt ll">铁凝 </a>
            <a @click="leaderName($event)" class="l_txt ll">彭清华</a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">张庆伟</a>
            <a @click="leaderName($event)" class="l_txt ll">洛桑江村</a>
            <a @click="leaderName($event)" class="l_txt ll">雪克来提·扎克尔</a>
          </td>
          <td class="t3"><a href="#" class="l_txt"></a></td>
          <td class="t4"><a href="#" class="l_txt ll"></a></td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">全国人大秘书长：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">刘奇 </a>
          </td>
          <td class="t3"><a href="#" class="l_txt"></a></td>
          <td class="t4"><a href="#" class="l_txt ll"></a></td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">中央军委主席：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">习近平</a>
          </td>
          <td class="t3">
            <a @click="leaderName($event)" class="l_txt">副主席：</a>
          </td>
          <td class="t4">
            <a @click="leaderName($event)" class="l_txt ll">张又侠</a>
            <a @click="leaderName($event)" class="l_txt ll">何卫东</a>
          </td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">全国政协主席：</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">王沪宁</a>
          </td>
          <td class="t3"><a href="#" class="l_txt"></a></td>
          <td class="t4"><a href="#" class="l_txt ll"></a></td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">全国政协副主席:</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">石泰峰 </a>
            <a @click="leaderName($event)" class="l_txt ll">胡春华 </a>
            <a @click="leaderName($event)" class="l_txt ll">沈跃跃 </a>
            <a @click="leaderName($event)" class="l_txt ll">王勇 </a>
            <a @click="leaderName($event)" class="l_txt ll">周强 </a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">帕巴拉·格列朗杰 </a>
            <a @click="leaderName($event)" class="l_txt ll">何厚铧 </a>
            <a @click="leaderName($event)" class="l_txt ll">梁振英 </a>
            <a @click="leaderName($event)" class="l_txt ll">巴特尔 </a>
            <a @click="leaderName($event)" class="l_txt ll">苏辉 </a>
            <a @click="leaderName($event)" class="l_txt ll">邵鸿 </a>

            <a @click="leaderName($event)" class="l_txt ll">高云龙 </a>
            <a @click="leaderName($event)" class="l_txt ll">陈武 </a>
            <a @click="leaderName($event)" class="l_txt ll">穆虹 </a>
            <a @click="leaderName($event)" class="l_txt ll">咸辉 </a>
            <a @click="leaderName($event)" class="l_txt ll">王东峰 </a>
            <a @click="leaderName($event)" class="l_txt ll">姜信治 </a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">蒋作君 </a>
            <a @click="leaderName($event)" class="l_txt ll">何报翔 </a>
            <a @click="leaderName($event)" class="l_txt ll">王光谦 </a>
            <a @click="leaderName($event)" class="l_txt ll">秦博勇 </a>
            <a @click="leaderName($event)" class="l_txt ll">朱永新 </a>
            <a @click="leaderName($event)" class="l_txt ll">杨震 </a>
            <br />
            <!--<a href='javascript:SGoAttrWith("220101","政协副主席,马飚")' class="l_txt ll">马飚 </a>-->
          </td>
        </tr>
        <tr>
          <td class="t1">
            <a @click="leaderName($event)" class="l_txt">全国政协秘书长:</a>
          </td>
          <td class="t2">
            <a @click="leaderName($event)" class="l_txt ll">王东峰（兼）</a>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 移动端 -->
    <table
      border="0"
      cellpadding="0"
      cellspacing="0"
      class="list"
      v-if="windowWidth < 769"
    >
      <div>
        <div class="row-style">
          <div colspan="4" style="font-weight: bold; color: #ac0002">
            二十届中央领导机构
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">国家主席：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">习近平</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">副主席：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">韩正</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">国务院总理：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">李强</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">国务院副总理：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">丁薛祥</a>
            <a @click="leaderName($event)" class="l_txt ll">何立峰 </a>
            <a @click="leaderName($event)" class="l_txt ll">张国清 </a>
            <a @click="leaderName($event)" class="l_txt ll">刘国中 </a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">国务委员：</a>
          </div>
          <div class="t2">
            <!--<a href='javascript:SGoAttrWith("220101","国务委员,李尚福")' class="l_txt ll">李尚福 </a>-->
            <a @click="leaderName($event)" class="l_txt ll">王小洪</a>
            <a @click="leaderName($event)" class="l_txt ll">吴政隆</a>
            <a @click="leaderName($event)" class="l_txt ll">谌贻琴</a>
            <!--<a href='javascript:SGoAttrWith("220101","国务委员,秦刚")' class="l_txt ll">秦刚</a>-->
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">国务院秘书长：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">吴政隆（兼）</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">全国人大委员长：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">赵乐际</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">全国人大副委员长：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">李鸿忠</a>
            <a @click="leaderName($event)" class="l_txt ll">王东明</a>
            <a @click="leaderName($event)" class="l_txt ll">肖捷 </a>
            <a @click="leaderName($event)" class="l_txt ll">郑建邦</a>
            <a @click="leaderName($event)" class="l_txt ll">丁仲礼</a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">郝明金</a>

            <a @click="leaderName($event)" class="l_txt ll">蔡达峰</a>
            <a @click="leaderName($event)" class="l_txt ll">何维</a>

            <a @click="leaderName($event)" class="l_txt ll">武维华</a>
            <a @click="leaderName($event)" class="l_txt ll">铁凝 </a>
            <a @click="leaderName($event)" class="l_txt ll">彭清华</a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">张庆伟</a>
            <a @click="leaderName($event)" class="l_txt ll">洛桑江村</a>
            <a @click="leaderName($event)" class="l_txt ll">雪克来提·扎克尔</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">全国人大秘书长：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">刘奇 </a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">中央军委主席：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">习近平</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">副主席：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">张又侠</a>
            <a @click="leaderName($event)" class="l_txt ll">何卫东</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">全国政协主席：</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">王沪宁</a>
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">全国政协副主席:</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">石泰峰 </a>
            <a @click="leaderName($event)" class="l_txt ll">胡春华 </a>
            <a @click="leaderName($event)" class="l_txt ll">沈跃跃 </a>
            <a @click="leaderName($event)" class="l_txt ll">王勇 </a>
            <a @click="leaderName($event)" class="l_txt ll">周强 </a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">帕巴拉·格列朗杰 </a>
            <a @click="leaderName($event)" class="l_txt ll">何厚铧 </a>
            <a @click="leaderName($event)" class="l_txt ll">梁振英 </a>
            <a @click="leaderName($event)" class="l_txt ll">巴特尔 </a>
            <a @click="leaderName($event)" class="l_txt ll">苏辉 </a>
            <a @click="leaderName($event)" class="l_txt ll">邵鸿 </a>

            <a @click="leaderName($event)" class="l_txt ll">高云龙 </a>
            <a @click="leaderName($event)" class="l_txt ll">陈武 </a>
            <a @click="leaderName($event)" class="l_txt ll">穆虹 </a>
            <a @click="leaderName($event)" class="l_txt ll">咸辉 </a>
            <a @click="leaderName($event)" class="l_txt ll">王东峰 </a>
            <a @click="leaderName($event)" class="l_txt ll">姜信治 </a>
            <br />
            <a @click="leaderName($event)" class="l_txt ll">蒋作君 </a>
            <a @click="leaderName($event)" class="l_txt ll">何报翔 </a>
            <a @click="leaderName($event)" class="l_txt ll">王光谦 </a>
            <a @click="leaderName($event)" class="l_txt ll">秦博勇 </a>
            <a @click="leaderName($event)" class="l_txt ll">朱永新 </a>
            <a @click="leaderName($event)" class="l_txt ll">杨震 </a>
            <br />
            <!--<a href='javascript:SGoAttrWith("220101","政协副主席,马飚")' class="l_txt ll">马飚 </a>-->
          </div>
        </div>
        <div class="row-style">
          <div class="t1">
            <a @click="leaderName($event)" class="l_txt">全国政协秘书长:</a>
          </div>
          <div class="t2">
            <a @click="leaderName($event)" class="l_txt ll">王东峰（兼）</a>
          </div>
        </div>
      </div>
    </table>
  </div>
</template>

<script>
// import {
//   getArticleList,
// } from "../../../../require/api";
export default {
  name: "NationalLeadership",
  methods:{
    // // 首次进入列表页面 获取列表
    // async leaderName(event) {
    //   console.log(event.target.innerText);
    //     const param = {
    //       uid:'A31001',
    //       curpage: 1,
    //       pagesize: 20,
    //       isdefault: false,
    //       webChannelTypeId: "1",
    //       attr:event.target.innerText
    //     };
    //     this.loadingState = true;
    //     const { data: data } = await getArticleList(param);
    //     console.log(data);
    // }
    leaderName(event){
      // 向父组件传递了两个值
      this.$emit('leaderName', event.target.innerText);
    }
  }
};
</script>

<style lang="less" scoped>
.latelybox1 {
  border-bottom: 1px solid #ececec;
  width: 811px;
  overflow: hidden;
  padding-bottom: 20px;
  .list {
    border-collapse: collapse;
    width: 759px;
    margin: 20px auto;
    td {
      padding: 4px 16px 4px 16px;
    }
    .t1 {
      width: 21%;
    }
    .t2 {
      width: 48%;
    }
    .t3 {
      width: 12%;
    }
    .t4 {
      width: 20%;
    }
    .ll {
      font-weight: 400 !important;
      padding: 4px 4px;
      cursor: pointer;
    }
    .l_txt {
      font-weight: bold;
      font-family: "微软雅黑";
      color: #535353;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
@media screen and (max-width: 769px) {
  .latelybox1 {
    width: 100% !important;
    .list {
      width: 100%;
      .row-style {
        margin-bottom: 16px;
        .t1 {
          width: 126px;
          display: inline-block;
        }
        .t2 {
          width: calc(100% - 126px);
          display: inline-block;
          vertical-align: middle;
          a {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>